import { render, staticRenderFns } from "./RealEstateGroupDetail.vue?vue&type=template&id=efdb53f6"
import script from "./RealEstateGroupDetail.vue?vue&type=script&lang=js"
export * from "./RealEstateGroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports